<template>
  <modal :show.sync="show" modalClasses="modal-hide-footer">
    <h3 slot="header" class="mb-0">Legal Status</h3>
    <div v-if="_gAuth.isAppSas() ">
    <!-- ✅ Table if Data Exists -->
    <div v-if="tableData.length > 0" class="rounded-bottom">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column
          prop="legal_sts_loan_statue"
          label="Facility"
          min-width="180"
          width="auto">
          <template slot-scope="scope">
            <p class="top-line">{{ scope.row.legal_sts_loan_statue }}</p>
          </template>
        </el-table-column>

        <el-table-column
          prop="legal_sts_current_outstanding"
          label="Outstanding (RM)"
          min-width="200"
          width="auto">
          <template slot-scope="scope">
            <p class="top-line">{{ scope.row.legal_sts_current_outstanding | moneyFormatter }}</p>
          </template>
        </el-table-column>

        <el-table-column
          prop="legal_sts_current_installment"
          label="Instalment (RM)"
          min-width="200"
          width="auto">
          <template slot-scope="scope">
            <p class="top-line">{{ scope.row.legal_sts_current_installment | moneyFormatter }}</p>
          </template>
        </el-table-column>
      </el-table>
    </div>
       <!-- ✅ Empty state -->
    <div v-else class="bg-light p-3 text-center rounded-bottom">
      <p class="text-xs">No Legal Status recorded</p>
    </div>
 </div>
 <div v-else class="p-3 rounded-bottom">
 
  <table class="legal-cases-table bordered summary-table" style="width: 100%">
    <thead>
      <tr>
        <th style="width: 60px">No.</th>
        <th>Case Type</th>
        <th>Amount</th>
        <th>Plaintiff</th>
        <th>Status</th>
        <th>Subject Comments</th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="(legalCase, index) in normalizedLegalCasesSummary"
        :key="'summary-' + index"
      >
        <td style="text-align: center">{{ index + 1 }}.</td>
        <td>{{ legalCase.case_type || '-' }}</td>
        <td style="text-align: center">
          {{ formatCaseAmount(legalCase) }}
        </td>
        <td>{{ legalCase.plaintiff || '-' }}</td>
        <td>
          {{ legalCase.latest_status || '-' }}
        </td>
        <td>
          {{ legalCase.subject_comment || '-' }}
        </td>
      </tr>
      <tr v-if="normalizedLegalCasesSummary.length === 0">
        <td colspan="6" class="text-center">No Information Available</td>
      </tr>
    </tbody>
  </table>
</div>
  </modal>
</template>

<script>
import Modal from "@/components/Modal";
import { Table, TableColumn } from "element-ui";

export default {
  name: "LegalStatusModal",
  props: {
    legalSts: {
      type: Array,
      default: () => []
    },
    legalCasesResp: {
      type: [Array, Object],
      default: () => [],
    },
    legalCasesSummary: {
      type: [Array, Object],
      default: () => [],
    },
    reservePrice: {
      type: [String, Number],
      default: null,
    },
    show_legal_status_full_view: Boolean
  },
  components: {
    Modal,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  data() {
    return {
      tableData: []
    };
  },
  computed: {
    show: {
      get() {
        return this.show_legal_status_full_view;
      },
      set(value) {
        this.$emit("update:show_legal_status_full_view", value);
      }
    },
   // NEW: For the summary table using legalCasesSummary
    normalizedLegalCasesSummary() {
        if (Array.isArray(this.legalCasesSummary)) {
            return this.legalCasesSummary;
        } else if (
            this.legalCasesSummary &&
            typeof this.legalCasesSummary === "object"
        ) {
            // If it's a single object, wrap it in an array
            return [this.legalCasesSummary];
        }
        return [];
    },
    // NEW: Normalize legalCasesResp for consistent handling
    normalizedLegalCasesResp() {
        if (Array.isArray(this.legalCasesResp)) {
            return this.legalCasesResp;
        } else if (
            this.legalCasesResp &&
            typeof this.legalCasesResp === "object"
        ) {
            return [this.legalCasesResp];
        }
        return [];
    },
  },
   methods: {
     formatReservePrice(price) {
      if (!price) return "0";
      return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    
 formatCaseAmount(legalCase) {      
    // First check if there's an amount in the legalCase object
    if (legalCase.amount && legalCase.amount > 0) {
        return `RM ${this.formatReservePrice(legalCase.amount)}`;
    }
    
    if (legalCase.case_amt && legalCase.case_amt > 0) {
        return `RM ${this.formatReservePrice(legalCase.case_amt)}`;
    }
    
    // Find matching case in legalCasesResp by case type and plaintiff
    if (this.normalizedLegalCasesResp.length > 0) {
        const matchingCase = this.normalizedLegalCasesResp.find(respCase => 
            respCase.title === legalCase.case_type && 
            respCase.plaintiff === legalCase.plaintiff
        );
        
        if (matchingCase && matchingCase.reserve_price && matchingCase.reserve_price > 0) {
            return `RM ${this.formatReservePrice(matchingCase.reserve_price)}`;
        }
    }
    
    return '-';
},
  },
  watch: {
    legalSts: {
      immediate: true,
      handler(val) {
        this.tableData = val && val.length > 0 ? val : [];
      }
    }
  },
//   mounted() {
//     console.log('Parent - CCRIS Derivatives:', this.crissDerivatives);
// }
};
</script>
<style scoped>
.summary-table th {
  background-color: #252938 !important;
  color: #fff !important;
  border: none !important;
  vertical-align: top !important;
  text-transform: none !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  line-height: 19.5px !important;
  padding: 9px 12px !important;
}

/* Regular table header styling (for detailed tables) */
.legal-cases-table:not(.summary-table) th {
  background-color: #a9a9a9 !important;
  background-image: none !important;
  color: #000 !important;
  font-weight: 700 !important;
  text-align: left;
  padding: 8px 6px;
}

.ccris-table td {
  vertical-align: middle;
}
.ccris-table .dark-col {
  background-color: #444;   /* dark gray */
  color: #fff;
  font-weight: bold;
  width: 25%;
}
.ccris-table .gray-col {
  background-color: #ddd;   /* light gray */
  font-weight: 500;
  width: 35%;
}
.ccris-table td:last-child {
  background-color: #fff;   /* white for values */
  text-align: left;
}
</style>